import { useState } from 'react';
import DetailForm from '../components/DetailForm';
import ManufacturerForm from '../components/ManufacturerForm';
import ProductForm from '../components/ProductForm';
import { useLanguage } from '../hooks/useLanguage';

const copy = {
  RU: { kicker: 'РЕДАКЦИЯ АРХИВА', title: 'Добавить запись', intro: 'Выберите тип новой каталожной записи.', product: 'Изделие', detail: 'Деталь', manufacturer: 'Производитель' },
  EN: { kicker: 'ARCHIVE DESK', title: 'Add a record', intro: 'Choose the type of catalogue record to create.', product: 'Example', detail: 'Part', manufacturer: 'Manufacturer' },
};

export default function AddArchive() {
  const [mode, setMode] = useState('detail');
  const { lang } = useLanguage();
  const labels = copy[lang] || copy.RU;
  const modes = [['product', labels.product], ['detail', labels.detail], ['manufacturer', labels.manufacturer]];

  return (
    <main className="admin-create page-width">
      <header><p className="section-kicker">{labels.kicker}</p><h1>{labels.title}</h1><p>{labels.intro}</p></header>
      <nav aria-label={labels.title}>{modes.map(([value, label]) => <button type="button" className={mode === value ? 'is-active' : ''} onClick={() => setMode(value)} key={value}>{label}</button>)}</nav>
      <section>{mode === 'product' && <ProductForm />}{mode === 'detail' && <DetailForm />}{mode === 'manufacturer' && <ManufacturerForm />}</section>
    </main>
  );
}
